import type * as BackendTypes from 'chaika-types';
import { DatesAsString } from '../backend';

export { MessageStatus, MessageChannel } from 'chaika-enums';

export interface TemplateViewData extends BackendTypes.TemplateViewModel {}
export interface MessageListQuery extends DatesAsString<BackendTypes.MessageListQuery> {}
export interface MessageListResponse extends Omit<BackendTypes.MessageListResponse, 'messages'> {
    messages: Message[];
}
export interface Message extends DatesAsString<BackendTypes.MessageViewModel> {}
export interface SendMessageParams extends BackendTypes.SendMessageParams {}
export interface SendEntryToEmailData extends BackendTypes.SendEntryToEmailForm {
    entryId: string;
}
export interface SendManualMessageParams extends Omit<BackendTypes.SendManualMessageForm, 'templateParams'> {
    templateParams: SendMessageTemplaateParams | PracticeChatMessageeParams;
}
export interface TemplateCreationParams extends BackendTypes.TemplateCreationParams {}
export interface TemplateUpdateParams extends BackendTypes.TemplateUpdateParams {}

export interface SendMessageTemplaateParams {
    date: string;
    organizationName: string;
    userFullName: string;
    userPhone?: string;
    telegram?: string;
    subscriptionOrderChat?: string;
    text?: string;
}

export interface PracticeChatMessageeParams {
    practiceName: string;
    practiceChat: string;
    text: string;
}

export const enum ManualTemplateNames {
    RenderedServiceAddedToWalkIn = 'RenderedServiceAddedToWalkIn',
    EntryDoctorContacts = 'EntryDoctorContacts',
    PracticeChatRequest = 'PracticeChatRequest',
    CheckPersonalData = 'CheckPersonalData',
}
